import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import Layout from 'components/common/Layout';
import Button from 'components/common/Button';

import { appTitle, titleSeparator } from 'config/helmetSettings';

const styles = () => ({
  section: {
    position: 'relative',
    maxWidth: 800,
    height: '80vh',
    padding: '0 16px',
    margin: '24px auto 0',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
});

const PaymentCancel = ({ classes }) => (
  <Layout variant="error">
    <Helmet>
      <title>
        {appTitle} {titleSeparator} Payment Canceled
      </title>
    </Helmet>
    <div className={classes.section}>
      <Grid
        direction="column"
        container
        spacing={24}
        align="center"
      >
        <Grid item>
          <Typography align="center" variant="title" gutterBottom>
            Payment Canceled!
          </Typography>
        </Grid>
        <Grid item>
          <Button
            href="/settings/payment/dashboard"
            variant="raised"
            color="primary"
          >
            Payment Dashboard
          </Button>
        </Grid>
      </Grid>
    </div>
  </Layout>
);

PaymentCancel.propTypes = {
  classes: PropTypes.shape({
    section: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(PaymentCancel);



// WEBPACK FOOTER //
// ./src/pages/settings/PaymentCancel.js